<script>
import DataProvider from './DataProvider.vue';
import MemberRepository from '../../js/repository/MemberRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: MemberRepository.findStocktaking,
                params: [this.clubId, this.date],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
